import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { ReactComponent as CheckCircle } from '@pflegia/ui/icons/check-circle.svg';

interface CheckListProps {
  checkListItems: (string | React.ReactNode)[];
  multiColumn?: boolean;
}

const CheckList: React.FC<CheckListProps> = ({ checkListItems, multiColumn = false, ...rest }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <ul className={clsx(multiColumn && 'md:grid md:grid-cols-2')} {...rest}>
      {checkListItems.filter(Boolean).map((text, index) => (
        <li
          data-testid={`check-list-item-${index}`}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className='text-default mb-4 flex gap-2 break-words hyphens-auto'
          lang={language}>
          <CheckCircle className='text-primary mt-1 shrink-0' height={16} width={16} />
          {text}
        </li>
      ))}
    </ul>
  );
};

export default CheckList;
